import { Stack } from '@workramp/ui';
import styled from 'styled-components';

export const StyledStack = styled(Stack)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(8)}px;
`;

export const AdvancedSearchContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(6)}px;
  margin-bottom: ${({ theme }) => theme.spacing(8)}px;
`;

export const AnswerSection = styled.div`
  flex: 1;
  padding-right: ${({ theme }) => theme.spacing(4)}px;
`;

export const SourcesSection = styled.div`
  min-width: 300px;
  padding-left: ${({ theme }) => theme.spacing(4)}px;
`;

export const SourceItem = styled.div<{ isLast?: boolean }>`
  margin-bottom: ${({ isLast, theme }) => (isLast ? '0' : theme.spacing(2))}px;
`;

export const StyledAdvancedSearchStack = styled(Stack)`
  border: 1px solid ${({ theme }) => theme.colors.primary[200]};
  border-radius: 10px;
`;
